import { Box, Card, Stack, Text } from '@mantine/core'
import type { VisitWithRelations } from '@markku/types'

interface VisitNotesCardProps {
  visit: VisitWithRelations
}

export function VisitNotesCard({ visit }: VisitNotesCardProps) {
  const videoAttachment = visit.attachments?.find(
    (a) => a.metadata?.type === 'visit_video',
  )

  if (!visit.notes && !videoAttachment) {
    return null
  }

  return (
    <Card withBorder>
      <Stack gap="md">
        {visit.notes && (
          <Box>
            <Text size="lg" fw={600} mb="xs">
              Markun huomiot
            </Text>
            <Text size="sm" c="dimmed">
              {visit.notes}
            </Text>
          </Box>
        )}

        {videoAttachment?.downloadUrl && (
          <Box>
            <Text size="lg" fw={600} mb="xs">
              Videotiivistelmä
            </Text>
            <video
              src={videoAttachment.downloadUrl}
              controls
              style={{
                width: '100%',
                borderRadius: 'var(--mantine-radius-default)',
              }}
            />
          </Box>
        )}
      </Stack>
    </Card>
  )
}
